<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ clientIds: value.id }"
    @rowClicked="showRowDetails"
    rememberLastClick
    :selectable="true"
    @update:selected="(ids) => (selectedIds = ids)"
  >
    <template v-slot:topbar-actions>
      <AllOperationsDialogs ref="allOps" @reload="reload" />
      <v-spacer />
      <OMenuButton :menuOpts="menuOpts" />
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './client-history-columns'
import AllOperationsDialogs from '../../operations/AllOperationsDialogs.vue'
import { ClientHistory } from '@/models'
import TheUser from 'oderon-vue/auth/TheUser'

export default {
  // chamado pelo TabbedInterface qdo a tab é ativada
  expose: ['reload'],
  tabTitle: 'Histórico',
  tabGroup: 'Módulo',
  tabBadgeFn: (client) => {
    if (client.isLost) {
      return { icon: 'mdi-skull', color: 'black' }
    }

    if (client.hasTrouble) {
      // 'mdi-exclamation-thick'
      // mdi-alert-circle
      return { icon: 'mdi-exclamation-thick', color: 'deep-orange' }
    }
  },
  components: {
    GenericReport,
    AllOperationsDialogs
  },
  props: {
    value: { required: true }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Exportar Excel',
          icon: 'mdi-file-excel',
          onClick: () => this.$refs.report.checkDownload()
        },
        {
          text: 'Cancelar registros...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.doCancelMany()
        }
      ]
    }
  },
  data() {
    return {
      TheUser,
      reportSpec: {
        code: 'history',
        title: 'Histórico',
        apiBase: '/history',
        filters: [
          { type: 'HistoryType', prefix: 'types', noSuffix: true },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar cancelados',
            defVal: false
          }
        ]
      },
      adapterSpec: fullSpec,

      selectedIds: []
    }
  },

  methods: {
    reload() {
      this.$refs.report.reload()
    },
    showRowDetails({ row }) {
      this.$refs.allOps.startEdit(row)
    },
    async doCancelMany() {
      let len = this.selectedIds.length
      let res = await this.$confirm({
        title: 'Confirmar Remoção em Lote',
        message: `Tem certeza que deseja remover ${len} registros?`,
        cancelText: 'Não, cancelar',
        okText: 'Sim, remover'
      })

      if (res) {
        this.$rootLoading(async () => {
          for (let id of this.selectedIds) {
            await ClientHistory.delete(id)
          }
          this.$snack(`${len} registros removidos com sucesso`)
          this.$refs.report.reload()
        })
      }
    },

    async doChangeMany() {
      let historyIds = this.selectedIds
      let res = await this.$refs.adjustCCAndProductDialog.open({ historyIds })

      if (res === 'RELOAD') {
        this.$refs.report.reload()
      }
    }
  }
}
</script>

<style></style>
